/**
 * Site Object
 * Scopes our various inits into a single object literal
 */
var site = {

  /**
   * Feature JS
   */
  featureJS: function(){
    //no-js
    $("html").removeClass("no-js");
    //no-svg
    if (!feature.svg) {
      $("html").addClass("no-svg");
    }
    //no-flexbox
    if (!feature.cssFlexbox) {
      $("html").addClass("no-flexbox");
    }
  },

  /**
   * Parallax init
   */
  plax: function(){
    $('.js-parallax').parallax(6, 'false');
  },

  /**
   * Slick Slider Init
   */
   sliders: function() {
     $('.js-slider').slick({
         infinite: !0,
         autoplay: !0,
         autoplaySpeed: 3e3
     }),

     $('.js-quote-slider').slick({
         infinite: !0,
         speed: 500,
         fade: !0,
         cssEase: "linear"
     })
   },

  /**
   * FancyBox inits
   */
  lightboxes: function(){
    $(".js-historic").fancybox({
      afterLoad: function() {
        this.title = '<a href="' + this.title + '" target="_blank" class="btn btn--dark">Download</a>'
      },
      helpers: {
        title: {
          type: "inside"
        }
      }
    })

    $(".js-video").fancybox({
      width: 1200,
      padding: 0,
      tpl: {
        wrap: '<div class="fancybox-wrap flex-vid"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>',
        closeBtn: '<a title="Close" class="fancybox-item fancybox-close" href="javascript:;"></a>'
    },
      helpers: {
        media: {}
      },
      beforeShow: function() {}
    })

    $('.js-video').fancybox({
      width: 1200,
      padding: 0,
      tpl: {
        wrap: '<div class="fancybox-wrap flex-vid"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>',
        closeBtn : '<a title="Close" class="fancybox-item fancybox-close" href="javascript:;"><i class="icon-x"></i></a>',
      },
      helpers : {
        media : {}
      },
      beforeShow: function () {}
    });
  }
};


/**
 * Doc Ready Init
 */
$(function(){

  site.featureJS();

  if ($('.js-parallax').length) {
    site.plax();
  }

  if ($('.js-slider, .js-quote-slider').length) {
    site.sliders();
  }

  if ($('.js-video, .js-historic').length){
    site.lightboxes();
  }
});
